/**
 * @param href {string}
 * @returns {boolean}
 */
module.exports = function isLinkBackToTheSamePage(href) {
    return window.location.href === href ||
        window.location.href + '/' === href ||
        window.location.href + '/#' === href ||
        window.location.href + '#' === href;
}
